import { Invoice } from "./invoice";
import { InvoiceReceipt } from "./invoice-receipt";
import { PersonAccount } from "./person-account";
import { SystemField } from "./system-field";
import { User } from "./user";

export class Receipt extends SystemField{
     
     received_from_id?:string;
     amount?:number;
     receipt_num?:string;
     received_by_id?:string;
     location_id?:string;
     receipt_date?:string;
     bank_id?:string;
     payment_method_id?:string;
     payment_method?:string;
     status?:string;
     cash_account_id?:string;
     amount_base_currency?:number;
     receipt_type?:string;
     finance_charge?: number;
     invoices_count?: number;
     invoice_receipts_count?: number;
     langs?: any;
     source?:string;
    received_from?: PersonAccount;
    received_by?: User;
    invoice_receipts?: InvoiceReceipt;
    invoices?: Invoice;
    total_receipt_amount?: number = 0;
}
export class ReceiptTranslation extends SystemField{
     
     lang_code?:string;
     comments?:string;
     receipts_id?:string;
}
